const ORDER = ["XS", "S", "M", "L", "XL", "XXL", "FREE SIZE"];
const isFree = (s) => s.toUpperCase() === "FREE SIZE";

export const sizesOf = (item) => (item.size || "").split(/[,/|]/).map((x) => x.trim()).filter(Boolean);

export const thriftSizes = (items) => {
  const seen = new Map();
  items.flatMap(sizesOf).forEach((s) => seen.has(s.toUpperCase()) || seen.set(s.toUpperCase(), s));
  const rank = (k) => (ORDER.indexOf(k) === -1 ? 99 : ORDER.indexOf(k));
  return [...seen.entries()].sort(([a], [b]) => rank(a) - rank(b) || a.localeCompare(b)).map(([, v]) => v);
};

export const fitsSize = (item, size) => {
  if (!size) return true;
  const mine = sizesOf(item);
  return mine.some((s) => s.toUpperCase() === size.toUpperCase() || (!isFree(size) && isFree(s)));
};

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const ThriftSizeChips = ({ sizes, value, onChange, prefix = "thrift", kind = "size", format = (s) => s, allLabel = "All sizes" }) => (
  <div data-testid={`${prefix}-${kind}-chips`} role="radiogroup" aria-label={`Filter by ${kind}`} className="flex gap-2 overflow-x-auto no-scrollbar px-4 mb-8 justify-start sm:justify-center">
    {[null, ...sizes].map((s) => {
      const on = value === s;
      return (
        <button key={s || "all"} type="button" role="radio" aria-checked={on} data-testid={`${prefix}-${kind}-chip-${s ? slug(s) : "all"}`} onClick={() => onChange(s)} className={`shrink-0 h-9 px-4 rounded-full font-mono text-[10px] uppercase tracking-[0.2em] border transition-[background-color,border-color,color] duration-200 ${on ? "bg-[#C5A059] border-[#C5A059] text-[#0F0F0F]" : "border-[#0F0F0F]/20 text-[#0F0F0F]/70 hover:border-[#B38F46] hover:text-[#0F0F0F]"}`}>
          {s ? format(s) : allLabel}
        </button>
      );
    })}
  </div>
);
